import {sortByKey} from './sort-by-key';

export const sortObject = (key, asc) => (
  arrayOfObjects => [...arrayOfObjects].sort((a, b) => sortByKey(a, b, key, asc))
);
